import { Key, storage } from '@soluto-private/mx-context';

import { BasePlanDetails } from '@soluto-private/mx-types';

export const getLanguage = (): string => storage.get(Key.Language);
export const getPartner = (): string => storage.get(Key.Client);
export const getPlans = (): BasePlanDetails[] => storage.get(Key.Plans);
export const getServices = (): string[] => storage.get(Key.Services);
